__turbopack_context__.v({
  "caption": "recipient-step-module-scss-module__lHy9RG__caption",
  "grid": "recipient-step-module-scss-module__lHy9RG__grid",
  "root": "recipient-step-module-scss-module__lHy9RG__root",
  "submit": "recipient-step-module-scss-module__lHy9RG__submit",
  "wide": "recipient-step-module-scss-module__lHy9RG__wide",
});
